<template>
    <div data-toggle="tooltip" data-placement="top" :title="schedule.status">
        <i class="status-icon fas fa-circle" :class="{'text-success' : schedule.is_past, 'text-warning' : schedule.is_now, 'text-info' : schedule.is_coming }"></i>
    </div>
</template>
<script>
    export default {
        props: {
            schedule: {
                type: Object,
                required: true,
            }
        }
    }
</script>